const calculateOtherCountriesPercentage = (mainCountries, restCountries) => {
  try {
    const mainCountriesStudentsCount = mainCountries
      .map((country) => country.students.length)
      .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
    const restCountriesStudentsCount = restCountries
      .map((country) => country.students.length)
      .reduce((accumulator, currentValue) => accumulator + currentValue, 0)

    return (
      (restCountriesStudentsCount / (mainCountriesStudentsCount + restCountriesStudentsCount)) * 100
    )
  } catch (e) {
    console.error(e)
    return 0
  }
}

export default calculateOtherCountriesPercentage
